/**
 * Formateo de fechas en español para Inside CRM.
 * Acepta strings ISO (YYYY-MM-DD o YYYY-MM-DDTHH:MM:SS), Date, o null.
 * Si la entrada es inválida o nula, devuelve cadena vacía (no rompe la UI).
 */

const _parse = (value) => {
  if (!value) return null;
  if (value instanceof Date) return Number.isNaN(value.getTime()) ? null : value;
  // YYYY-MM-DD sin hora → interpretarlo como fecha local (no UTC) para evitar desfases en TZ negativas
  const s = String(value).trim();
  if (/^\d{4}-\d{2}-\d{2}$/.test(s)) {
    const [y, m, d] = s.split('-').map(Number);
    const dt = new Date(y, m - 1, d);
    return Number.isNaN(dt.getTime()) ? null : dt;
  }
  const dt = new Date(s);
  return Number.isNaN(dt.getTime()) ? null : dt;
};

const _pad = (n) => String(n).padStart(2, '0');

/** "31/12/2026" — formato largo dd/mm/yyyy. */
export const formatFecha = (value) => {
  const dt = _parse(value);
  if (!dt) return '';
  return `${_pad(dt.getDate())}/${_pad(dt.getMonth() + 1)}/${dt.getFullYear()}`;
};

/** "31 dic" — formato corto día y mes abreviado en español. */
export const formatFechaCorta = (value) => {
  const dt = _parse(value);
  if (!dt) return '';
  const meses = ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'];
  return `${_pad(dt.getDate())} ${meses[dt.getMonth()]}`;
};

/**
 * "hace 3 días" / "en 5 días" / "hoy" / "ayer" / "mañana".
 * Para diferencias > 30 días devuelve formatFecha(value).
 */
export const formatRelativo = (value, ref = new Date()) => {
  const dt = _parse(value);
  if (!dt) return '';
  // Comparar a nivel de día (resetear horas)
  const a = new Date(dt.getFullYear(), dt.getMonth(), dt.getDate());
  const b = new Date(ref.getFullYear(), ref.getMonth(), ref.getDate());
  const diffDias = Math.round((a.getTime() - b.getTime()) / (24 * 60 * 60 * 1000));
  if (diffDias === 0) return 'hoy';
  if (diffDias === -1) return 'ayer';
  if (diffDias === 1) return 'mañana';
  if (diffDias > 1 && diffDias <= 30) return `en ${diffDias} días`;
  if (diffDias < -1 && diffDias >= -30) return `hace ${Math.abs(diffDias)} días`;
  return formatFecha(value);
};

export default { formatFecha, formatFechaCorta, formatRelativo };
